import { createFileRoute } from '@tanstack/react-router';
import { ActivityTopic } from '../screens/company/topics/ActivityTopic';

export const Route = createFileRoute('/t/$tenant/settings/company/activity')({
  component: ActivityTopic,
});
